'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _IDTextbox2 = require('./IDTextbox');

var _IDTextbox3 = _interopRequireDefault(_IDTextbox2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IDUrl = function (_IDTextbox) {
    (0, _inherits3.default)(IDUrl, _IDTextbox);

    function IDUrl() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, IDUrl);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IDUrl.__proto__ || (0, _getPrototypeOf2.default)(IDUrl)).call.apply(_ref, [this].concat(args))), _this), _this.dataTestID = 'url', _this.inputType = 'url', _this.onClear = function () {
            _this.setValue('');
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(IDUrl, [{
        key: 'renderPlaceholder',
        value: function renderPlaceholder() {
            var options = this.props.options;

            if (_lodash2.default.get(options, 'prefix')) {
                return null;
            }
            return (0, _get3.default)(IDUrl.prototype.__proto__ || (0, _getPrototypeOf2.default)(IDUrl.prototype), 'renderPlaceholder', this).call(this);
        }
    }]);
    return IDUrl;
}(_IDTextbox3.default);

exports.default = IDUrl;


IDUrl.defaultProps = (0, _extends3.default)({}, _IDTextbox3.default.defaultProps, {
    type: "cleave",
    iconType: 'chrome',
    inputCls: 'input-url',
    options: {
        prefix: "http://",
        lowercase: true,
        prefixLength: 0
    }
});